import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WellbeingHubComponent } from './wellbeing-hub.component';
import { WellbeingHubRoutingModule } from './wellbeing-hub-routing.module';
import { ComponentsModule } from 'src/app/shared/components/components.module';

@NgModule({
  declarations: [
    WellbeingHubComponent
  ],
  imports: [
    CommonModule,
    WellbeingHubRoutingModule,
    ComponentsModule
  ]
})
export class WellbeingHubModule { }
